import React from 'react';
import { Bold } from './Bold';

export const boldIntlText = (str: React.ReactNode) => <Bold>{str}</Bold>;
